import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import {exportReservations} from "../../shared/queries";
import {Accomodation} from "../../types";
import dayjs from "dayjs";
import {RootState} from "../index";

type ReportState = {
    fromDate: number,
    year: number,
    dataUrl?: string,
    accommodation?: Accomodation,
    loading: {
        report: boolean
    }
}

export const fetchReport = createAsyncThunk(
    'accountingReportSlice/fetchReport',
    async (_, { getState }) => {
        try {
            const state = getState() as RootState
            if (!state.reportSlice.accommodation || !state.reportSlice.accommodation.idAccomodation) return ''
            const blob = await exportReservations<any>({
                filters: {
                    page: 0,
                    pageOffset: 0,
                    criterias: [],
                    sortType: 'DESC',
                    orderBy: 'idBooking',
                    maxResults: 5000
                },
                year: state.reportSlice.year,
                fromDate: parseInt(dayjs(state.reportSlice.fromDate).format('YYYYMMDD')),
                toDate: parseInt(dayjs(state.reportSlice.fromDate).format('YYYYMMDD')),
                columns: [],
                accomodations: {
                    [state.reportSlice.accommodation.idAccomodation]: state.reportSlice.accommodation.accomodationName
                }
            })
            return window.URL.createObjectURL(blob as any)
        } catch (e) {
            console.log(e)
            return ''
        }
    }
)

const accountingReportSlice = createSlice({
    name: 'hotels',
    initialState: {
        fromDate: parseInt(dayjs().format('YYYYMMDD')),
        dataUrl: undefined,
        year: parseInt(dayjs().format('YYYY')),
        loading: {
            report: false
        },
        accommodation: undefined
    } as ReportState,
    reducers: {
        setAccommodation: (state, action) => {
            state.accommodation = action.payload
        },
        setYear: (state, action) => {
            state.year = action.payload
        },
    },
    extraReducers: builder => {
        builder.addCase(fetchReport.pending, (state) => {
            state.loading.report = true
        })
        builder.addCase(fetchReport.rejected, (state) => {
            state.loading.report = false
        })
        builder.addCase(fetchReport.fulfilled, (state, action: PayloadAction<string>) => {
            state.dataUrl = action.payload
            state.loading.report = false
        })
    }
})

export const {
    setAccommodation,
    setYear
} = accountingReportSlice.actions

export default accountingReportSlice.reducer
